import { TFunction } from 'i18next';

export const formatCourseInstanceString = (
  nCourseInstances = 0,
  t: TFunction,
) => {
  return t('utils.courseInstance.courseInstance', { count: nCourseInstances });
};
